export interface MmuUserPreferences {
  dateFormat: DateFormat;
  timeFormat: TimeFormat;
  temperatureUnit: TemperatureUnit;
  numberFormat: NumberFormat;
  measurementSystem: MeasurementSystem;
}

export enum DateFormat {
  DD_MM_YYYY_DOT = 'dd.MM.yyyy',
  D_M_YYYY_DOT = 'd.M.yyyy',
  DD_MM_YYYY_SLASH = 'dd/MM/yyyy',
  MM_DD_YYYY_SLASH = 'MM/dd/yyyy',
  DD_MM_YYYY_MINUS = 'dd-MM-yyyy',
  YYYY_MM_DD_MINUS = 'yyyy-MM-dd'
}

export enum TimeFormat {
  H12 = '12-hour',
  H24 = '24-hour'
}

export enum TemperatureUnit {
  CELSIUS = 'C',
  FAHRENHEIT = 'F'
}

export enum NumberFormat {
  PERIOD_SEPARATED = 'period-separated',
  COMMA_SEPARATED = 'comma-separated',
  SPACE_SEPARATED = 'space-separated'
}

export enum MeasurementSystem {
  METRIC = 'metric',
  IMPERIAL_US = 'imperial-us',
  IMPERIAL_UK = 'imperial-uk'
}
